import { useCallback } from "react";
import { Accordion, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type ProductCheckboxFilterProps = {
  options: any;
  title: string;
  type: string;
  filter: any;
  setFilter: any;
};

export default function CheckboxAccordion({
  title,
  options,
  type,
  filter,
  setFilter,
}: ProductCheckboxFilterProps) {
  const handleInput = useCallback(
    (event: any) => {
      setFilter((prevFilter: any) => {
        const checked = event.target.checked;
        let updatedFilter = prevFilter;
        if (!checked) {
          updatedFilter[type] = updatedFilter?.[type]?.filter(
            (v: any) => v !== event.target.value,
          );
        } else {
          updatedFilter[type].push(event.target.value);
        }

        return { ...updatedFilter };
      });
    },
    [setFilter, type],
  );
  const { t } = useTranslation();

  return (
    <Accordion className="filter-accordion mb-3" defaultActiveKey={"0"}>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flex: 1,
              paddingRight: "8px",
            }}
          >
            {title}
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <Form>
            {options.map((opt: any, idx: number) => (
              <Form.Check
                key={idx}
                type="checkbox"
                id={`checkbox-${idx}-${type}`}
                label={
                  <span style={{ textTransform: "capitalize" }}>
                    {t(`${type}-${opt}`, opt)}
                  </span>
                }
                checked={filter[type]?.includes(opt)}
                onChange={handleInput}
                className="mb-2"
                value={opt}
              />
            ))}
          </Form>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
